import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';

import PopupBox from '../PopupBox.js';


import Countdown from '../Countdown.js';




export default class List extends React.Component {
  render() {



    //handle the click on one of the buttons
    const handleClick = (e) => {

      //if the id value of the button and compare to the correct answer
      if( parseInt(e.target.getAttribute("value")) == this.props.correct_answer)
      { 
        this.props.setResult(true, this)
      }
      else
      {
        this.props.setResult(false, this)
      }


      






    };


    var buttons = []


    

    for(var i = 0; i < this.props.options.length; i ++)
    {
       
        buttons.push(
            <Button value={i} onClick={handleClick} variant="danger" className="m-1 d-flex p-2 wide-btn" size="lg">{this.props.options[i]}</Button>  
        )
        buttons.push(
           
        )
    }
    
   

    return (



      <PopupBox position={this.props.position} getPos={this.props.getPos} question={this}>


  <Countdown time_allowed={60} getPos={this.props.getPos} question={this} setResult={this.props.setResult}></Countdown>

          
     
        <h2 className="text-danger">{this.props.question}</h2>

        
        <br></br>

        <div className="d-flex justify-content-center">
          <ButtonToolbar>
            {buttons}
          </ButtonToolbar>
        </div>

      </PopupBox>

    );
  }
}
